var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodIcon = function SvgFoodIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m22.168 18.373-1.155 1.155 9.56 9.56L28.662 31l-9.56-9.56L9.54 31l-1.912-1.912 12.627-12.627c-.795-1.97.027-4.806 2.19-6.972 2.64-2.64 6.28-3.282 8.127-1.434 1.849 1.849 1.206 5.487-1.433 8.126-2.166 2.166-5.002 2.988-6.972 2.192zM8.585 7.1l9.082 9.081-3.824 3.825-5.26-5.26a5.41 5.41 0 0 1 0-7.646zm20.077 2.866c.616.617.266 2.603-1.435 4.302-1.7 1.7-3.686 2.05-4.3 1.435-.617-.617-.267-2.603 1.432-4.304 1.7-1.7 3.686-2.05 4.303-1.433",
    clipRule: "evenodd"
  })));
};
export default SvgFoodIcon;